import { render, staticRenderFns } from "./NewItem.vue?vue&type=template&id=45e8cf6b&scoped=true"
import script from "./NewItem.vue?vue&type=script&lang=js"
export * from "./NewItem.vue?vue&type=script&lang=js"
import style0 from "./NewItem.vue?vue&type=style&index=0&id=45e8cf6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e8cf6b",
  null
  
)

export default component.exports